module.exports = __webpack_public_path__ + "static/media/invoices_icon.6851a196.svg";